import gql from 'graphql-tag';

export default gql`
  query GetAsset($assetId: String!){
    getAsset(assetId: $assetId) {
      assetId
      organisationId
      filename
      title
      description
      tags
      altText
      metaData
      folders {
        tagId
        label
        color
      }
      createdAt
      updatedAt
      permissions
      createdByUser {
        firstName
        lastName
        userId
      }
      updatedByUser {
        firstName
        lastName
      }
      assetFiles {
        THUMBNAIL {
          assetFileId
          type
          status
          sourceUrl
          metaData
        }
        ORIGINAL {
          assetFileId
          type
          status
          sourceUrl
          metaData
        }
        HD {
          assetFileId
          type
          status
          sourceUrl
          metaData
        }
        SD {
          assetFileId
          type
          status
          sourceUrl
          metaData
        }
        CAPTION {
          assetFileId
          type
          status
          sourceUrl
          metaData
        },
        VTT_CAPTION {
          assetFileId
          type
          status
          sourceUrl
          metaData
        }
      }
    }
  }
`;